import type {
  HeartedHotel,
  IngredientId,
  SearchTerm,
} from '@libs/trip-planner-interfaces';

export type UpdateIngredientByIdData =
  UpdateStayIngredientSearchTextData | SetHeartedHotelData;

export const enum UpdateIngredientDataType {
  StayIngredientSearchText = 'StayIngredientSearchText',
  SetHeartedHotel = 'SetHeartedHotel',
}

interface BaseUpdateIngredientData {
  ingredientId: IngredientId;
}

export interface UpdateStayIngredientSearchTextData extends BaseUpdateIngredientData {
  updateType: UpdateIngredientDataType.StayIngredientSearchText;
  searchTerm: SearchTerm;
  shouldKeepFilters?: boolean;
}

export interface SetHeartedHotelData extends BaseUpdateIngredientData {
  updateType: UpdateIngredientDataType.SetHeartedHotel;
  heartedHotel: HeartedHotel;
}
